// extracted by mini-css-extract-plugin
export var actionButton = "_c8-5";
export var actionButtonActive = "_c8-6";
export var content = "_c8-3";
export var header = "_c8-4";
export var list = "_c8-7";
export var settingsContent = "_c8-a";
export var settingsPanel = "_c8-b";
export var settingsRow = "_c8-c";
export var state = "_c8-9";
export var triggerBadge = "_c8-2";
export var triggerButton = "_c8-1";
export var triggerShell = "_c8-0";
export var unreadDot = "_c8-8";